import React from "react";
import { InlineMath } from "react-katex";
import "katex/dist/katex.min.css";
import './MathPreview.css';

const MathPreview = ({ text }) => {
  const renderMathExpression = (text) => {
    // This function identifies LaTeX expressions wrapped in $$...$$
    const regex = /\$\$(.*?)\$\$/g;
    const parts = text.split(regex);
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        // Render LaTeX expression
        return <InlineMath key={index}>{part}</InlineMath>;
      }
      // Render normal text
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className="math-preview-container" style={{ fontSize: "1rem", lineHeight: "1.5" }}>
      {renderMathExpression(text)}
    </div>
  );
};

export default MathPreview;
